import {
  Button,
  Card,
  Dialog,
  List,
  Strong,
  Text,
  CheckIcon,
  PlusIcon,
  Heading,
  Link,
} from '@buffer-mono/popcorn'

import { Service } from '../../../../types'

import styles from '../../SwitchFromIGLoginToFBLogin.module.css'

import type { JSX } from 'react'

export function SwitchFromIGLoginToFBLoginCard({
  channelId,
}: {
  channelId: string
}): JSX.Element {
  const handleReconnect = (): void => {
    const { actions } = window.appshell || {}
    actions?.connectChannel({
      selectedService: Service.instagram,
      isRefreshingConnection: true,
      selectedRefreshChannelId: channelId,
    })
  }

  return (
    <Card className={styles.card}>
      <Heading as="h3" size="sm">
        All the features you have today plus
      </Heading>
      <List>
        <List.Item icon={CheckIcon}>
          <Text>Better posting reliability</Text>
        </List.Item>
        <List.Item icon={PlusIcon}>
          <Text>Add locations to posts</Text>
        </List.Item>
        <List.Item icon={PlusIcon}>
          <Text>Advanced analytics (paid plans)</Text>
        </List.Item>
      </List>

      <Button
        onClick={handleReconnect}
        disabled={!channelId}
        size="large"
        variant="primary"
        className={styles.action}
      >
        Reconnect Through Facebook
      </Button>
      <Dialog.Separator className={styles.separator} />
      <Text>
        ⚠️{' '}
        <Strong>
          Your Instagram account must be linked to a Facebook Page and you must
          be an Admin.
        </Strong>{' '}
        <Link
          href="https://support.buffer.com/articles/connecting-your-instagram-account-to-buffer-n9Ad6veXsu"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more here.
        </Link>
      </Text>
    </Card>
  )
}
